var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 8,
    viewBox: "0 0 34 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.2158 7.73438C29.7252 7.73454 29.2394 7.63807 28.7862 7.45049C28.3329 7.2629 27.921 6.98787 27.574 6.6411C27.227 6.29433 26.9517 5.88261 26.7638 5.42945C26.5759 4.97628 26.4792 4.49055 26.479 3.99998C26.4788 3.50942 26.5753 3.02362 26.7629 2.57034C26.9505 2.11706 27.2255 1.70516 27.5723 1.35816C27.9191 1.01117 28.3308 0.735877 28.7839 0.548C29.2371 0.360123 29.7228 0.263341 30.2134 0.263184C31.2041 0.262866 32.1544 0.656132 32.8552 1.35647C33.556 2.0568 33.9499 3.00684 33.9502 3.99758C33.9505 4.98833 33.5573 5.93862 32.8569 6.6394C32.1566 7.34019 31.2065 7.73407 30.2158 7.73438Z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.7344 7.4688C18.7969 7.4688 20.4688 5.79685 20.4688 3.7344C20.4688 1.67195 18.7969 0 16.7344 0C14.6719 0 13 1.67195 13 3.7344C13 5.79685 14.6719 7.4688 16.7344 7.4688Z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.5718 7.73442C6.63425 7.73442 8.3062 6.06248 8.3062 4.00002C8.3062 1.93757 6.63425 0.265625 4.5718 0.265625C2.50935 0.265625 0.837402 1.93757 0.837402 4.00002C0.837402 6.06248 2.50935 7.73442 4.5718 7.73442Z",
    fill: "#242424"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.cb3869b3e527390c9ebd2738df81a105.svg";
export { ForwardRef as ReactComponent };